import React, { useCallback } from "react";

import PropTypes from "prop-types";

import { toHERDCCodeOptions } from "components/flowable/ClassificationCodes/helpers";
import CodeTemplate from "components/flowable/ClassificationCodes/internal/CodeTemplate";
import { useDictionary } from "hooks";

const HERDCCode = ({ herdcMinimum, herdcMaximum, excludeSubcategories, ...rest }) => {
	const dictionary = useDictionary("classificationCodes.herdc");

	const toCodeOptions = useCallback(
		response => toHERDCCodeOptions(response, excludeSubcategories),
		[ excludeSubcategories ]
	);

	return (
		<CodeTemplate
			codeType="herdc"
			toCodeOptions={toCodeOptions}
			dictionary={dictionary}
			maximumNumberOfCodes={herdcMaximum}
			minimumNumberOfCodes={herdcMinimum}
			{...rest}
		/>
	);
};

HERDCCode.defaultProps = {
	herdcMinimum: 1,
	herdcMaximum: 4,
	includePercentage: true,
	excludeSubcategories: false,
};

HERDCCode.propTypes = {
	herdcMinimum: PropTypes.number,
	herdcMaximum: PropTypes.number,
	includePercentage: PropTypes.bool,
	excludeSubcategories: PropTypes.bool,
	value: PropTypes.any,
	label: PropTypes.string,
	isRequired: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	enabled: PropTypes.bool.isRequired,
};

export default HERDCCode;
